export default __webpack_public_path__ + "static/media/i4.eab7da3a.jpg";